import { render, staticRenderFns } from "./mytpp-certifications.vue?vue&type=template&id=3c1c0f20&scoped=true"
import script from "./mytpp-certifications.vue?vue&type=script&lang=js"
export * from "./mytpp-certifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c0f20",
  null
  
)

export default component.exports